import { DUMMY_STORY_ID } from '../../constants';
import SherloModule from '../../SherloModule';
function getStorybookComponent({ isTestingMode, params = {}, view, }) {
    if (isTestingMode) {
        const lastState = SherloModule.getLastState();
        const storyId = lastState === null || lastState === void 0 ? void 0 : lastState.nextSnapshot.storyId;
        const storybook7Params = {
            isUIHidden: true,
            isSplitPanelVisible: false,
            tabOpen: 0,
            shouldDisableKeyboardAvoidingView: true,
            keyboardAvoidingViewVerticalOffset: 0,
        };
        params = {
            ...params,
            host: undefined,
            enableWebsockets: false,
            onDeviceUI: false,
            shouldPersistSelection: false,
            initialSelection: storyId || DUMMY_STORY_ID,
            // These properties are only valid for Storybook 7
            ...storybook7Params,
        };
    }
    return view.getStorybookUI(params);
}
export default getStorybookComponent;
//# sourceMappingURL=getStorybookComponent.js.map